import React from 'react'

import richTextRenderer from '../../RichTextParser/RichTextParser'
import { renderedContent, titleStyling } from './TitleComponent.module.css'

const TitleComponent = ({ children, extraClassname, renderContent }) => {
  return renderContent ? (
    <div className={`${titleStyling} ${renderedContent} ${extraClassname}`}>
      {richTextRenderer(renderContent)}
    </div>
  ) : (
    <p className={`${titleStyling} ${extraClassname}`}>{children}</p>
  )
}

export default TitleComponent
